import '@/modules/card';
import Swiper from 'swiper';
import SwiperCore, { Pagination, Navigation, Scrollbar } from 'swiper/core';
import 'swiper/css';
SwiperCore.use([Pagination, Navigation, Scrollbar]);

export default class CollectionProductCarousel {
    constructor (sliderElement) {
        if (!sliderElement) return;

        this.sliderElement = sliderElement;
        this.sliderElementWrapper = sliderElement.closest('.js-collection-product-carousel-wrapper');
        this.slides = this.sliderElement.querySelectorAll('.js-slide');
        this.arrowNext = this.sliderElement.querySelector('.swiper-button-next');
        this.arrowPrev = this.sliderElement.querySelector('.swiper-button-prev');
        this.scrollbar = this.sliderElement.querySelector('.swiper-scrollbar');
        
        if (this.sliderElementWrapper) {
            this.slideToggles = this.sliderElementWrapper.querySelectorAll('.js-slides-toggle');
            this.carouselBtns = this.sliderElementWrapper.querySelector('.js-collection-product-carousel-btns');
        }

        if(this.slides) {
            const buttonType = this.slideToggles[0].dataset.type;
            this.slides.forEach((sliderSlide) => {
                const slideType = sliderSlide.dataset.type;
                if(buttonType == slideType) {
                    sliderSlide.classList.remove('!hidden');
                } else {
                    sliderSlide.classList.add('!hidden');
                }
            })
        }

        this.init()
    }

    init() {
        const swiper = new Swiper(this.sliderElement, {
            slidesPerView: 1.1,
            spaceBetween: 9,
            threshold: 10,
            speed: 400,
            navigation: {
                nextEl: this.arrowNext,
                prevEl: this.arrowPrev
            },
            scrollbar: {
                el: this.scrollbar,
                draggable: true,
                hide: false
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 16
                },
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 20
                }
            }
        });


        if (this.slideToggles) {
            this.slideToggles[0].classList.add('active');
            this.slideToggles.forEach(button => {
                button.addEventListener('click', () => {
                    if (this.carouselBtns) {
                        const buttonPosition = this.carouselBtns.querySelector(`#${button.dataset.type}`).getBoundingClientRect().left;
                        if (buttonPosition) {
                            this.carouselBtns.scrollLeft = buttonPosition;
                        }
                    }

                    this.slideToggles.forEach(buttonRemove => {
                        buttonRemove.classList.remove('active')
                    });

                    button.classList.add('active');
                    
                    this.slides.forEach((slide) => {
                        const slideType = slide.dataset.type;
                        const buttonType = button.dataset.type;
                        if(buttonType == slideType) {
                            slide.classList.remove('!hidden');
                        } else {
                            slide.classList.add('!hidden');
                        }
                    })
    
                    // Slide to start when slides change
                    swiper.slideTo(0);
                    swiper.scrollbar.setTranslate(0);
                    swiper.update();
                });
            });
        }
    }
}